import { useContext, useEffect } from "react"
import styles from "./index.module.scss"
import { GenerateContext } from "../../../hooks/GenerateContext"
import { GENERATE_MODE, IMAGE_TYPE, MODEL_PROVIDER } from "@utils/CONST"
import Iconfont from '@utils/Iconfont';
import { message, Tooltip, Popover } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const GenerateMode = (props) => {
    const {
        no1MultiAngleImage,
        generateMode, setGenerateMode,
        modelProvider
    } = useContext(GenerateContext)
    const { imageType } = props
    const isSotaModel = modelProvider == MODEL_PROVIDER.SOTA
    const isNecklaceTryon = imageType == IMAGE_TYPE.NECKLACE_TRYON
    const stdLabel = isNecklaceTryon ? "全能模型·标准2K" : (isSotaModel ? "标准模式2K" : "标准模式")
    const hqLabel = isNecklaceTryon ? "全能模型·高品质4K" : (isSotaModel ? "高品质模式4K" : "高品质模式")

    const items = [{
        value: GENERATE_MODE.STD,
        title: stdLabel,
        content: "生成速度更快",
        icon: <Iconfont type="icon-stdOutlined" />,
        iconActive: <Iconfont type="icon-stdFilled" />,
    }, {
        value: GENERATE_MODE.HQ,
        title: hqLabel,
        content: "生成效果更好",
        icon: <Iconfont type="icon-hdOutlined" />,
        iconActive: <Iconfont type="icon-hdFilled" />,
        // 限免
        // isLimit: true,
    }]

    useEffect(() => {
        if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO && no1MultiAngleImage) {
            setGenerateMode(GENERATE_MODE.HQ)
        }
    }, [imageType, no1MultiAngleImage])

    return (
        <div className={styles.Container}>
            <p className={styles.Title}>
                生成模式
                <Popover content={<p className={styles.PopoverContent}>
                    <p><span>{stdLabel}</span> 生成速度更快</p>
                    <p><span>{hqLabel}</span> 生成时间稍长，生成效果更好</p>
                </p>}>
                    <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                </Popover>
            </p>
            <div className={styles.PickerContent}>
                {
                    items.map(item => {
                        const disabledStd = imageType == IMAGE_TYPE.IMAGE_TO_VIDEO && no1MultiAngleImage && item.value == GENERATE_MODE.STD

                        if (disabledStd) {
                            return (
                                <Tooltip key={item.value} title="首尾帧生成视频仅支持高品质模式！" placement="top">
                                    <div
                                        className={`${styles.PickerItem} ${isNecklaceTryon ? styles.NecklacePickerItem : ''} ${item.isLimit && styles.isLimit} ${generateMode == item.value && styles.actived}`}
                                        onClick={() => {
                                            message.warning("首尾帧生成视频仅支持高品质模式！", 5)
                                        }}
                                    >
                                        <div className={`${styles.Title} ${isNecklaceTryon ? styles.NecklaceTitle : ''}`}>
                                            {!isNecklaceTryon && (generateMode == item.value ? item.iconActive : item.icon)}
                                            <span>{item.title}</span>
                                        </div>
                                        {/* <span className={styles.Content}>{item.content}</span> */}
                                    </div>
                                </Tooltip>
                            )
                        }

                        return (
                            <div
                                key={item.value}
                                className={`${styles.PickerItem} ${isNecklaceTryon ? styles.NecklacePickerItem : ''} ${item.isLimit && styles.isLimit} ${generateMode == item.value && styles.actived}`}
                                onClick={() => setGenerateMode(item.value)}
                            >
                                <div className={`${styles.Title} ${isNecklaceTryon ? styles.NecklaceTitle : ''}`}>
                                    {!isNecklaceTryon && (generateMode == item.value ? item.iconActive : item.icon)}
                                    <span>{item.title}</span>
                                </div>
                                {/* <span className={styles.Content}>{item.content}</span> */}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default GenerateMode
